import type { Ticket } from '@/types/tickets';

/**
 * Retorna true se o usuário atual é responsável principal OU co-responsável do ticket.
 * Usado para indicador "Novo pra mim", filtro "Meus tickets", esconder botão "Atribuir para mim".
 */
export function isAssignedToMe(
  ticket: Pick<Ticket, 'assigned_to' | 'coAssignees'>,
  currentUserId: number | null | undefined
): boolean {
  if (!currentUserId) return false;
  if (ticket.assigned_to === currentUserId) return true;
  return ticket.coAssignees?.some(u => u.id === currentUserId) ?? false;
}
